<template>
  <a-popover :title="result && result.label" v-if="showPop">
    <template slot="content">
      <div class="content__list">
        <a-row v-for="(item, index) in result.details" :key="index">
          <a-col :span="8">{{ item.startTime }}s-{{ item.endTime }}s&nbsp;{{ item.label }}</a-col>
          <a-col :span="16">
            {{ item.text }}
          </a-col>
        </a-row>
      </div>
    </template>
    <slot></slot>
  </a-popover>
</template>

<script>
export default {
  props: ['reason'],
  data() {
    return {
      result: {
        label: '',
        details: []
      }
    }
  },
  computed: {
    showPop() {
      return this.result && this.result.label !== '正常'
    }
  },
  async mounted() {
    const { details, label } = JSON.parse(this.reason)
    this.result.label = label
    let indexArr = new Set()
    const length = details.length
    details.forEach((element, index) => {
      if (element.label !== '正常') {
        indexArr.add(index)
        for (let i = 1; i <= 3; i++) {
          if (index - i >= 0) {
            indexArr.add(index - i)
          }
          if (index + i < length) {
            indexArr.add(index + i)
          }
        }
      }
    })
    indexArr = Array.from(indexArr)
    this.result.details = details.filter((item, index) => indexArr.includes(index))
  }
}
</script>

<style scoped>
.content__list {
  width: 500px;
  max-height: 400px;
  overflow-y: auto;
}
</style>
